<template>
  <div class="wf-node wf-start">
    <div class="wf-start__icon">
      <Icon name="flag" class="w-5 h-5" />
    </div>
    <div class="wf-start__label">{{ data.name || 'Start' }}</div>
    <Handle id="start-out" type="source" :position="Position.Right" />
  </div>
</template>

<script>
import { Handle, Position } from '@vue-flow/core';
import Icon from '@/ui-components/Icon.vue';

export default {
  name: 'StartNode',
  components: { Handle, Icon },
  props: {
    data: { type: Object, default: () => ({}) },
  },
  data() {
    return { Position };
  },
};
</script>
